// extracted by mini-css-extract-plugin
module.exports = {"container":"card_container__3Pj3L","img":"card_img__2AZXw","header":"card_header__3CJq0","info":"card_info__1-PZF","item":"card_item__M23FO","value":"card_value__2Ni6f"};